//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Epk.WebControls.ElektronickaPodpisovaKnihaDetail.ts		</Name>
//    <Description> Detail elektronické podpisové knihy								</Description>
//    <Author>      thazmuka														</Author>
//    <Copyright>   © GORDIC spol. s r. o. 1993-2019								</Copyright>
//    <Created>     2019-03-21														</Created>
//  </FileHeader>

namespace Gordic.Epk.WebControls {

    export interface GEpkDetailDlgInputParams {
        Ixp: string,
        SerCislo: number | string,
        supervisor?: Gordic.Wfl.Interface.EpkSupervisorEnum,
        /** pomocná hodnota pro procházení detailů (ze seznamu) */
        Grid?: JQuery<HTMLElement>,
        Mobile?: boolean
    }

    interface IEpkDetailSimplePanels {
        souhrn: boolean,
        historieschvalovani: boolean,
        overenipodpisu: boolean,
        poznamky: boolean,
        souvisejici: boolean
    }
    interface IEpkDetailExtendPanels {
        souhrn: boolean,
        nahled: boolean,
        souvisejici: boolean,
        poznamky: boolean
    }

	const { gcontent } = Decorators;

  


	/**
	 * Seznam elektronické podpisové knihy
	 */
	@gcontent
    export class GEpkDetail extends GContentBase<GEpkDbParamsNew> {

		//#region *** parametry ***

        /** příznak vlastní žádosti */
        OwnRequest: boolean;
        /** detail pouze ke čtení */
        //ReadOnly: boolean;
        /** Ovládání šipek na průchod mezi detaily */
        ArrowControl: boolean;
        /** data řádku */
        row: Gordic.Wfl.Interface.GPodpisovaKnihaDto;

        private Tabulka: string;
		/** existuje úkon schválení */
		private existujeUkonSchvaleni = false;
		/** informace o přidaném souboru */
		private fileInfo: EpkFileInfo;
		/** element badgeFile */
		private badgeFile: JQuery<HTMLElement>;
		/** nastavení pro procházení detailů pomocí šípek */
		private listControls_setup: any;
		/** natvrdo, kdyztak nastavim, kdyz bude potreba */
		private BtnPovoleniPredatKPosouzeni: boolean = true;
        /** EPK - text označující opakovaně předloženou žádost o vyřízení pro stejný dokument */
        private epk_txtopr: string | undefined;

		//#endregion

		//#region *** init ***

        /** refresh po zavření dialogu (pravděpodobně grid) */
        private refresh: boolean = false;
        /** flash na closingu */
        private flash: GFlashOptions;

        /** třída obecných metod */
        private common: GEpkCommon;
        /** c# třída společných akcí v epk */
        private epkAction: GContent;
        /** Počet ručně umístěných vizuálních podpisů */
        private VisualSignCount: number;
        /**
         * Identifikátor funkec aktuálně přihlášeného uživatele.
         */
        private ixsFunPrihlasenehoUzivatele: string;

		/** metoda pro odchod z contentu */
        public closing() {
     
			var def = $.Deferred();
			if (this.signing === true) {
				this.dialogs.alert("jres:32000323"); //RC 32000323 : Probíhá podepisování, nelze odejít!
				def.reject();
			}
			else {
                def.resolve({ refresh: this.refresh, flash: this.flash });
			}
			return def.promise();
		}

        private gfrmPanel: Gordic.Epk.WebControls.Sidebar.GEpkGfrmPanel;

        /** start */
        private start: any;


        private getRow(forward: boolean) {
            let parCnt: any = this.parentContent;
            if (parCnt != null && parCnt.data != null) {
                let data: Gordic.Wfl.Interface.GPodpisovaKnihaDto[] = parCnt.data;
                if (data.length === 0)
                    return null;
                let searchedIndex = 0;
                for (var i = 0; i < data.length; i++) {
                    if (this.row.ixp === data[i].ixp &&
                        this.row.ser_cislo === data[i].ser_cislo) {
                        // našel jsem správný řádek 
                        searchedIndex = i;
                        break;
                    }
                }

                let index = 0;
                if (forward === false) {
                    // index dalšího řádku
                    index = searchedIndex + 1;
                    // dostanu se mimo velikost pole
                    if (index >= data.length)
                        index = 0;  // vracím se na první index
                }
                else {
                    // index předchozího řádku
                    index = searchedIndex - 1;
                    // dostanu se mimo velikost pole
                    if (index < 0)
                        index = ((data.length)-1);  // vracím se na poslední index
                }

                
                // mám vybraný řádek
                let selectRow = data[index];
                return selectRow;
            }
            return null;
        }

        /**
         * finger touched start
         */
        private touchstart(event) {

            if (event == null || event.touches == null)
                return;

            if (event.touches.length === 1) {
                let item = event.touches.item(0);
                if (item == null)
                    return;
                //just one finger touched
                this.start = item.clientX;
            }
            else {
                //a second finger hit the screen, abort the touch
                this.start = null;
            }
        }

        /**
        * finger touched end
        */
        private touchend(event) {

            if (event == null || event.changedTouches == null)
                return;

            var offset = 100;//at least 100px are a swipe
            if (this.start) {
                let item = event.changedTouches.item(0);
                if (item == null)
                    return;
                //the only finger that hit the screen left it
                var end = item.clientX;
                if (end > this.start + offset) {
                    console.log("a left -> right swipe");
                    let row = this.getRow(true);
                    if (row != null) {
                        this.Ixp = row.ixp;
                        this.SerCislo = row.ser_cislo;
                        this._load();
                    }
                }
                else if (end < this.start - offset) {
                    console.log("a right -> left swipe");
                    let row = this.getRow(false);
                    if (row != null) {
                        this.Ixp = row.ixp;
                        this.SerCislo = row.ser_cislo;
                        this._load();
                    }
                }
            }
        }

        private initTouch() {

            // události už jsou zaregistrované
            if (this.Reload === true)
                return;

            let main = this.element[0];

            main.addEventListener("touchstart", (ev) => {
                console.info("touchstart");
                this.touchstart(ev);
            }, { passive: true, /*once: true*/ })
            main.addEventListener("touchend", (ev) => {
                console.info("touchend");
                this.touchend(ev);
            }, { passive: true, /*once: true*/ })
        }

        Ixp?: string | null;

        SerCislo?: number | null;

        /** příznak přenačtení detailu žádosti */
        Reload: boolean;

        private _load() {
            this.Reload = true;
            return this.load();
        }


        public onContentReady() {

            this.element.attr("id", "EpkDetail");
            this.log.info("Probíhá načítání detailu EPK z TS strany.");
            this.epkAction = new GContent("Gordic.Epk.WebControls.GEpkActionsService");

            this.hideFlash("idFlashDetailOnlyRead");
            this.hideFlash("idFlashDetailRqPending");
            this.hideFlash("idFlashDetailEmpty");
            this.hideFlash("idUpresneniPozadavku");

            if (this.ReadOnly === true) {
                this.showFlash({
                    id: "idFlashDetailOnlyRead",
                    content: "jres:32000920", //RC 32000920 : Detail žádosti je pouze ke čtení.
                    state: "info"
                });
            }

            // jedná se o nevyřízenou žádost
            if (this.row != null && this.row.zpus_vyriz != null && this.row.zpus_vyriz === 0) {
                if (this.row.vyriz_async != null && this.row.vyriz_async > 0) {
                    this.showFlash({
                        id: "idFlashDetailRqPending",
                        content: "jres:32001049", //RC 32001049 : Žádost může být právě vyřizována, zkuste prosím později.
                        state: "info"
                    });
                }
            }

            if (this.row == null) {
                this.showFlash({
                    id: "idFlashDetailEmpty",
                    content: "jres:32000526", //RC 32000526 : Detail žádosti je prázdný.
                    state: "warning"
                });
                return; 
            }

            //RC 32000105 : Detail žádosti
            this.title = "jres:32000105 " + this.row.ixp + " | Věc: " + this.row.vec;

            if (this.row.typ_pozad_pod_txt != null && this.row.typ_pozad_pod_txt !== "") {
                //RC 32000445 : Upřesnění požadavku
                this.showFlash({
                    id: "idUpresneniPozadavku",
                    content: "jres:32000445: " + "\"" + this.row.typ_pozad_pod_txt + "\"", //RC 32000445 : Upřesnění požadavku
                    state: "info"
                });
            }

            this.init();

            this.setDataToForm();
            this.setStatesOnButtons();

            this.log.info("Detail žádosti v EPK byl načten.");

        }

        private init() {

            this.common = new GEpkCommon();
            this.setValues();

            var GinListControlsObject = (Gin.DetailBuilderComponents as any).GinListControls.create(this);
            this.actions.addRange(GinListControlsObject.actions);
            $.extend(this, GinListControlsObject.contentExtensions);

            this.createSidebar();
            this.showAttachment();

            this.createMenuBar(GinListControlsObject.menubar);
            this.setStatusButton();

            this.common.preSetStates({
                cnt: this,
                row: this.row,
                sessionIxsFunFlag: this.common.isRequestMineAndActive(this.row, this.ixsFunPrihlasenehoUzivatele),
                setChecks: true,
                multi: false
            });

            //#region ** vytvořit šipky na procházení detailu **

            this.listControls_setup({
                rowToDto: function (gridState) {
                    return {
                        Ixp: gridState.currentRow.data.ixp,
                        SerCislo: gridState.currentRow.data.ser_cislo,
                    };
                },
                //template pro tooltip na šipce následující
                nextItemTemplate: "Následující detail: {ixp}",
                //template pro tooltip na šipce předchozí
                prevItemTemplate: "Předchozí detail: {ixp}"
            });
            (this as any).listControls_updateCaptions();

            //#endregion

            this.createCommandBar();

            // Pozice obrázku doplněného po přidání el. podpisu (např. do PDF)
            // Pokud není 0, zapne se umísťovací komponenta 
            // Vizuální umístění podpisu
            // 1- Ano, 2- Ano, včetně příloh
            if (this.EpkParams.gin_pdf_pictpos !== 0 && this.EpkParams.epk_povumipod !== 0) {
                // indikace ruč. vizuálního podpisu
                if (this.VisualSignCount > 0) {
                    new GEpkActionsService().updateBadgeUmisteniPodpisu(this, true);
                }
            }

        }

        private createCommandBar() {
            var params: MenuParams[] = [];
            params.push({
                action: this.actions.add(new GAction({
                    name: "actClose",
                    caption: "jres:32000023", //RC 32000023 : Zavřít
                    run: (ev, ctx) => {
                        this.tryClose();
                    }
                }))
            })
            this.commandBar(params);
        }

        private getParams(zpusobVyrizeni: Gordic.Wfl.Interface.GWflczpvEnum, duvodVyrizeni: boolean) {

            this.hideFlash("idFlashVyriditState");

            if (this.vyriditState == null) {
                this.showFlash({
                    id: "idFlashVyriditState",
                    state: "warning",
                    content: "jres:32000674" //RC 32000674 : Nelze provést vyřízení žádosti, není nastaven stav vyřízení.
                });
                return null;
            }

            var params: Wfl.Interface.GEpkCompleteConfigDto = {                 
                Ixp: this.row.ixp!,
                SerCislo: this.row.ser_cislo!,
                IxsDpo: this.row.ixs_dpo!,
                TypPozadavku: this.vyriditState,
                ZpusobVyrizeni: zpusobVyrizeni,
                DuvodVyrizeni: duvodVyrizeni,
                CasRazitko: this.casoveRazitko.checked,
                CasRazitkoPrilohy: this.casoveRazitkoPriloha.checked, // thazmuka (14.4.2020)
                PodepsatObraz: this.podepsat.checked,
                PodepsatPrilohy: this.podepsatPrilohy.checked,
                PredPodepsanimKonvertovat: this.zkonvertovat.checked,
                ZkonvertovatPrilohy: this.zkonvertovatPrilohy.checked,
                PodepsatPrilohyNePdf: this.podepsatPrilohyNePDF.checked,
                GuidGFRM: ""
            }

            return params;

        }

        private addActionSouvisejici(menuBar: MenuParams[]) {
            // související
            menuBar.push({
                visiblePriority: 2,
                action: this.actions.add(new GAction({
                    name: "actSouvisejici",
                    run: () => {
                        if (this.row == null || this.row.ixp == null)
                            return;
                        Gordic.Wfl.Dialogs.SouvisejiciDokumentyDlg(this, {
                            Ixp: this.row.ixp,

                        }, Gordic.Global.Enums.ModOtevreni.showModalWindow);
                    },
                    caption: "jres:32000009" //RC 32000009 : Související
                })),
                align: "opposite",
                favorite: false
            })
        }

        /** automacké otevření detailu */
        private autoDetailRun: boolean;

        private selectTypeOfClose() {

            // pokud je možné otevřít dialog odeslání z důvodu povolení DB parametru (ssl_epk_odes)
            // a zároveň máme k dispozici nějaké připravené zásilky
            // v tomto případě občerstvím detail a otevřu dialog odeslání
            if (this.checkOdeslani() === true) {
                this._load()
                    .then(() => {
                        this.openOdeslani(this.row.ixp!);
                    })
            }
            else {
                // aktivní automatické otevření dalšího detailu žádosti
                // možné nastavit v možnostech v aplikace
                if (this.autoDetailRun === true) {
                    if (this.actions.actListControlsNextRecord != null) {
                        // akce přejít na další detail žádosti je k dispozici
                        var enabled = this.actions.actListControlsNextRecord.enabled();
                        if (enabled === true) {
                            // otevřu další detail žádosti
                            this.actions.actListControlsNextRecord.run();
                            return;
                        }
                    }
                }
                // ve výchozím stavu se vrátím na seznam
                this.tryClose();
            }

        }

        /** kontrola, jestli můžu otevřít dialog odeslání */
        private checkOdeslani() {
            if (this.EpkParams.ssl_epk_odes != null && this.EpkParams.ssl_epk_odes > 0) {
                if (this.row.prip_zasil_pocet != null && this.row.prip_zasil_pocet > 0) {
                    return true;
                }
            }
            return false;
        }

        /**
         * otevření dialogu odeslání
         * @param ixp identifikátor dokumentu
         */
        private openOdeslani(ixp: string) {
            return Gordic.Wfl.Dialogs.GOdeslaniDlg(this, { Ixp: ixp }, Gordic.Global.Enums.ModOtevreni.showModalWindow);
        }

        private zobrazitSoubor(guid): void {
            var that = this;
            //this.beginOperation();

            var dto = {
                DownloaderType: "Gordic.Wfl.WebClient.WflGuidDownloader",
                AutoDownload: true,
                DisablePluginDownload: false,
                CustomData: {
                    "Guid": guid
                }
            };

            var doc = new GDocument(this);
            this.log.trace("zobrazitSoubor guid:" + guid);
            doc.downloadDocument(dto)
                .then(function () {
                    that.log.trace("Proběhlo stažení souboru.");
                },
                    function () {
                        that.log.trace("Stažení nedopadlo");
                        return;
                    })
                .always(function () {
                    var file = new GFile();
                    file.removeFile(guid);
                });
                
        }

        /**
         * Příznak odmítnutí
         * - pro žádosti vrácené k přepracování, které jsou v aktivní tabulce wflszps
         */
        private refused_flag?: number;

        private createMenuBar(arrows: any[]) {

            var menuBar: MenuParams[] = [];
            this.hideFlash("IdCheckShipmentFlash");

            // pouze vyřízené
            if (this.ReadOnly === true && this.row.zpus_vyriz === 1) {
                if (this.EpkParams.ssl_epk_odes != null && this.EpkParams.ssl_epk_odes > 0) {
                    var zasilkaEnabled = this.row.prip_zasil_pocet != null && this.row.prip_zasil_pocet > 0 ? true : false;

                    if (zasilkaEnabled === true)
                        this.showFlash("jres:32000840", "info", "IdCheckShipmentFlash"); //RC 32000840 : Je k dispozici odeslání zásilky

                    // odeslání zásilek (thazmuka 13.6.2022)
                    menuBar.push({
                        visiblePriority: 4,
                        action: this.actions.add(new GAction({
                            name: "actCheckShipment",
                            caption: "jres:32000839",		//RC 32000839 : Odeslání zásilky
                            icon: "gi-mail g-state-text g-state-info",
                            run: () => {
                                this.openOdeslani(this.row.ixp!);
                            },
                            enabled: zasilkaEnabled
                        })),
                        favorite: true
                    })
                }
            }

            if (this.ReadOnly === false && this.row.zpus_vyriz === 0) {

                //#region -- umístění podpisu --

                if (this.EpkParams.gin_pdf_pictpos !== 0 && this.EpkParams.epk_povumipod !== 0)
                    menuBar.push(new GEpkActionsService().getParamActionSignatureLocation(this, "actUmistitPodpis", true));

                //#endregion

                if (this.EpkParams.ssl_epk_vyrid! > 0) {        // thazmuka 25.11.2021 - zobrazovat tlačítka pouze pokud lze vyřídit dle DB parametru T16062

                    //#region -- upřesnit vyřízení --

                    var nastaveniVyrizeni: MenuParams = {
                        action: this.actions.add(new GAction({
                            name: "actNastaveniVyrizeni",
                            caption: "jres:32000256",		//RC 32000256 : Upřesnit vyřízení
                            run: () => {
                                this.common.showUpresneniVyrizeni(this, this.common.isRequestMineAndActive(this.row, this.ixsFunPrihlasenehoUzivatele));
                            }
                        }))
                    };

                    //#endregion

                    //#region -- vyřízení žádosti --

                    var actVyrizeni = this.actions.add(new GAction({
                        name: "actVyrizeni",
                        enabled: false,
                        icon: "fa-check-circle g-state-text g-state-success",
                        caption: "jres:32000064",							//RC 32000064 : Nelze vyřídit
                        run: () => {
                            if (this.validateDetail() === true) {

                                if (this.row === null)
                                    return;

                                $.Deferred().resolve().promise()
                                    .then(() => {
                                        if (this.gfrmPanel != null)
                                            return this.gfrmPanel.run(this.EpkParams.epk_gfrmzobr!, this.row?.akce_epk!);
                                        return null;
                                    })
                                    .then((saveDto) => {
                                        var guidGFRM: string = "";
                                        if (saveDto != null && saveDto.fileInfo != null && saveDto.fileInfo.guid != null) {
                                            guidGFRM = saveDto.fileInfo.guid;
                                        }
                                        const dto = this.getParams(Gordic.Wfl.Interface.GWflczpvEnum.Povoleno, false);
                                        if (dto != null) {
                                            dto.GuidGFRM = guidGFRM; // předat gfrm
                                            const done = () => {
                                                this.refresh = true;
                                                this.selectTypeOfClose();
                                            };
                                            const list: Wfl.Interface.GEpkCompleteConfigDto[] = [];
                                            list.push(dto);
                                            new Settlement({ cnt: this, done: done, row: this.row }).run(list);
                                        }
                                    })

                            }
                        }
                    }));

                    menuBar.push({
                        visiblePriority: 100,
                        action: actVyrizeni,
                        favorite: true,
                        children: [nastaveniVyrizeni]
                    })

                    //#endregion

                    //#region -- vrácení k přepracování --

                    menuBar.push({
                        visiblePriority: 90,
                        action: this.actions.add(new GAction({
                            name: "actVratit",
                            enabled: false,
                            icon: "fa-times-circle g-state-text g-state-error",
                            caption: "jres:32000040", //RC 32000040 : Vrátit k přepracování
                            tooltip: "jres:32000364", //RC 32000364 : Provede zamítnutí požadavku. V závislosti na stavu schvalovacího procesu může dojít k ukončení celého procesu.
                            run: () => {

                                if (this.row === null)
                                    return;

                                var dto = this.getParams(Gordic.Wfl.Interface.GWflczpvEnum.VracenoKPrepracovani, true);
                                if (dto != null) {
                                    const done = () => {
                                        this.refresh = true;
                                        this.selectTypeOfClose();
                                    };
                                    const list: Wfl.Interface.GEpkCompleteConfigDto[] = [];
                                    list.push(dto);
                                    new Settlement({ cnt: this, done: done, row: this.row }).run(list);
                                }
                           
                            }
                        })),
                        favorite: true
                    })

                    //#endregion

                    //#region -- předat k posouzení --

                    if (this.BtnPovoleniPredatKPosouzeni == true) {                // menu tlačítko "K posouzení" vytvořené na parametr
                        menuBar.push({
                            visiblePriority: 80,
                            action: this.actions.add(new GAction({
                                icon: "fa-gavel g-state-text g-state-info", // 10.02.2021 thazmuka - pridani ikony
                                name: "actKPosouzeni",
                                enabled: false,
                                run: () => {
                                    if (this.validateDetail() === true) {
                                        var rows: Gordic.Wfl.Interface.GPodpisovaKnihaDto[] = [];
                                        rows.push(this.row);
                                        new Epk.WebControls.Vyrizeni.PosouzeniEpk().predatKPosouzeniDaniNaVedomi(this, rows)
                                            .then(() => {
                                                this.refresh = true;
                                                this.selectTypeOfClose();
                                            });
                                    }
                                },
                                caption: "jres:26265003" //RC 26265003 : K posouzení
                            })),
                            favorite: true
                        })
                    }

                    //#endregion

                    const conversionParams: MenuParams = {
                        id: "idEpkConversionMenuParams",
                        action: this.actions.add(new GAction({
                            name: "actEpkConversion",
                            caption: "jres:32001061", //RC 32001061 : Vyhotovení PDF
                            run: () => {

                                if (this.Ixp == null)
                                    return;

                                Gordic.Wfl.Dialogs
                                    .GEpkConversionDlg(this, { Ixp: this.Ixp })
                                    .then(() => {
                                        this._load()
                                    })
                            }
                        }))
                    }
                    menuBar.push(conversionParams);

                    //#region -- vyřizující soubor --

                    var attachedFileOpen: MenuParams = {
                        action: this.actions.add(new GAction({
                            name: "actattachedFileOpen",
                            caption: "jres:32000881",		//RC 32000881 : Zobrazit/stáhnout soubor
                            run: () => {
                                if (this.fileInfo != null && this.fileInfo.guid != null && this.fileInfo.guid !== "") {
                                    this.zobrazitSoubor(this.fileInfo.guid);  
                                }
                            }
                        }))
                    };

                    menuBar.push({
                        children: [attachedFileOpen],
                        visiblePriority: 4,
                        action: this.actions.add(new GAction({
                            name: "actAttachedFile",
                            captionVisible: GAction.captionVisibility.never,
                            customClass: "attached_file_class",
                            caption: "jres:32000361",		//RC 32000361 : Přidat vyřizující soubor
                            icon: "fa-file attached_file_icon",
                            run: () => {
                                this.showPripojVyrizSoubor().done((data) => {
                                    this.fileInfo = data;
                                })
                            }
                        })),
                        align: "opposite",
                        favorite: true
                    })

                    //#endregion

                }
            }

            //#region -- zrušení vlastní žádosti --

            // nevyřízeno
            if (this.row.zpus_vyriz === 0) {
                if (this.EpkParams.ssl_epk_vyrid! > 0) {        // thazmuka 25.11.2021 - zobrazovat tlačítka pouze pokud lze vyřídit dle DB parametru T16062
                    if (this.OwnRequest === true)
                        menuBar.push(this.addZrusitZadostButton());
                }
            }
            // vráceno k přepracování (ale aktivní => wflszps) // T23822
            else if (this.row.zpus_vyriz === 2 && this.refused_flag != null && this.refused_flag > 0) {   
                if (this.EpkParams.ssl_epk_vyrid! > 0) {        // thazmuka 25.11.2021 - zobrazovat tlačítka pouze pokud lze vyřídit dle DB parametru T16062
                    if (this.OwnRequest === true)
                        menuBar.push(this.addZrusitZadostButton());
                }
            }

            //#endregion




            //#region -- související dokumenty/spisy --

            this.addActionSouvisejici(menuBar);

            //#endregion

            //#region -- otevřít detail dokumentu --

            menuBar.push({
                visiblePriority: 10,
                align: "opposite",
                action: this.actions.add(new GAction({
                    name: "actDetailDokument",
                    run: () => {
                        var options = {
                            DetailDto: { ixp: this.row.ixp! }
                        };
                        Gordic.Wfl.Dialogs.DetailDokumentuSpisu(this, options, Gordic.Gin.Globals.Enums.ModOtevreni.navigate);
                    },
                    icon: "gi-detail",
                    caption: "jres:32000658",//RC 32000658 : Detail dokumentu/spisu
                })),
                favorite: true
            });

            //#endregion

            //#region -- otevřít soubor --

            menuBar.push({
                visiblePriority: 5,
                align: "opposite",
                action: this.actions.add(new GAction({
                    name: "actOpenFile",
                    run: () => {

                        if (this.closed === true)
                            return;

                        if (this.fileSelectionRow == null || this.fileSelectionRow.Ixp == null) {
                            this.showFlash({ id: "idOpenAttachment", state: "warning", content: "jres:32000383" }); //RC 32000383 : Není k dispozici žádný soubor.
                            return;
                        }

                        //todo: beru v potaz verzi žádosti?? dle úprav co jsme dělali na náhledech nedávno?

                        Gordic.Wfl.AttachmentUtils.OpenAttachment(this, this.fileSelectionRow, true, false)
                            .then((output: { rv: "ok" | "uploaded" }) => {
                                if (this.closed === true)
                                    return;
                                if (output == null)
                                    return;
                                // pokud je vše OK, refreshnu detail
                                this._load();
                            })

                    },
                    tooltip: "jres:32000384",//RC 32000384 : Stáhnout a zobrazit soubor.
                    icon: "gi-download",
                    caption: "jres:32000382" //RC 32000382 : Zobrazit soubor
                })),
                favorite: true,
            });

            //#endregion 

            //#region -- šipky na procházení --

            if (this.ArrowControl === true) {
                menuBar.push.apply(menuBar, arrows);
            }

            //#endregion

            //#region -- sdílení --

            var share = Gordic.Gin.Prefabs.MenuParams.ShareCommandUrl({
                // 01.11.2022 - TFeik
                // Doplnění contentu pro zaregistrování akcí.
                parentContent: this,
                commandUrl: Gordic.WebApp.Utility.createCommandUrl(null, 'OpenDetail', {
                    ixx1: this.row.ixp,
                    ixx2: this.row.ser_cislo,
                    ixx3: Gin.Interface.GHledaniTypIxs.epkDetailZadost
                }),
                vlozitDoKalendareOptions: {
                    ixx: this.row.ixp as unknown as object,
                    ixs_fun: this.ixsFunPrihlasenehoUzivatele
                },
                prehledUdalostiOptions: {
                    ixp: this.row.ixp
                }
            })
            menuBar.push(share);

            //#endregion

            //#region -- občerstvení --

            menuBar.push({
                visiblePriority: 3,
                action: this.actions.add(new GAction({
                    name: "actRefresh",
                    caption: "jres:32000597",		//RC 32000597 : Občerstvit
                    icon: "gi-refresh",
                    run: () => {
                        this._load();

                    }
                })),
                align: "opposite",
            })

            //#endregion

            this.menuBar(menuBar);

        }

        /** 
         * Přidat tlačítko Zrušit žádost (do menu)
         * - musí být tvůrce žádosti
         * */
        private addZrusitZadostButton() {
            return {
                visiblePriority: 75,
                favorite: true,
                action: this.actions.add(new GAction({
                    enabled: true,
                    name: "actZrusitZadost",
                    icon: "fa-times-circle g-state-text g-state-error",
                    caption: "jres:32000494", //RC 32000494 : Zrušit žádost
                    tooltip: "jres:32000495", //RC 32000495 : Zrušit žádost do Elektronické podpisové knihy
                    run: () => {
                        //RC 32000500 : Dotaz //RC 32000501 : Opravdu chcete zrušit žádost?
                        this.dialogs.confirm("jres:32000500", "jres:32000501").on("close", (ev, retVal) => {
                            if (retVal && retVal === "yes") {
                                this.hideFlash("idZrusitZadostFlash");
                                this.epkAction.call("ZrusitZadostdoEPK", { Ixp: this.row.ixp, SerCislo: this.row.ser_cislo })
                                    .then(() => {

                                        this.flash = {
                                            content: "jres:32000497", //RC 32000497 : Žádost byla úspěšně zrušena.
                                            state: "success",
                                            id: "idZrusitZadostFlash"
                                        };
                                        this.refresh = true;
                                        this.tryClose();
                                    })
                            }
                        });

                    }
                }))
            } as MenuParams;
        }

        /**
         * nastavení vstupních hodnot
         */
        private setValues() {

            this.fileInfo = new EpkFileInfo();

            this.signing = false;

            this.menuSchvalit = { enabled: false };
            this.menuPosoudit = { enabled: false };
            this.menuZamitnout = { enabled: false };
            this.pridatVyrizSoubor = { enabled: false };

            //#region -- OBRAZ --

            this.podepsat = { enabled: false, checked: false, visible: true };
            this.schvalit = { enabled: false, checked: false, visible: true };
            this.podepsataschvalit = { enabled: false, checked: false, visible: true };
            this.posoudit = { enabled: false, checked: false, visible: true };
            this.vzitnavedomi = { enabled: false, checked: false, visible: true };
            // splnit (specialita pro Ukrajinu)
            this.splnit = { enabled: false, checked: false, visible: true };
            this.rozhodnout = { enabled: false, checked: false, visible: true }

            this.casoveRazitko = { enabled: false, checked: false, visible: true };
            this.zkonvertovat = { enabled: false, checked: false, visible: true };

            //#endregion

            //#region -- specialita MD --

            this.pridelit = new IEpkCheckBoxSetting(false, false, true);
            this.predat = new IEpkCheckBoxSetting(false, false, true);
            this.schvaleniVyrizeniSpisu = new IEpkCheckBoxSetting(false, false, true);

            //#endregion

            //#region -- PŘÍLOHY --

            this.podepsatPrilohy = { enabled: false, checked: false, visible: false };
            this.casoveRazitkoPriloha = { enabled: false, checked: false, visible: false };
            this.zkonvertovatPrilohy = { enabled: false, checked: false, visible: false };
            this.podepsatPrilohyNePDF = { enabled: false, checked: false, visible: false };

            //#endregion

        }

		/**
		 * hromadné nastavení stavů na tlačítkách v statusbaru a na hlavním tlačítku v menubaru 'Vyřízení'
		 */
		private setStatesOnButtons()  {

			var that = this;
			var stringSuffix = ".js-static";

            changeButtonOnStatusBar($(".podepsat_status_class" + stringSuffix).parent(), this.podepsat.checked, this.podepsat.enabled);
			changeButtonOnStatusBar($(".schvalit_status_class" + stringSuffix).parent(), this.schvalit.checked, this.schvalit.enabled);
			changeButtonOnStatusBar($(".posoudit_status_class" + stringSuffix).parent(), this.posoudit.checked, this.posoudit.enabled);
            changeButtonOnStatusBar($(".vzitnavedomi_status_class" + stringSuffix).parent(), this.vzitnavedomi.checked, this.vzitnavedomi.enabled);
            changeButtonOnStatusBar($(".splnit_status_class" + stringSuffix).parent(), this.splnit.checked, this.splnit.enabled);
            changeButtonOnStatusBar($(".rozhodnout_status_class" + stringSuffix).parent(), this.rozhodnout.checked, this.rozhodnout.enabled);

			changeButtonOnStatusBar($(".casrazitko_status_class" + stringSuffix).parent(), this.casoveRazitko.checked, this.casoveRazitko.enabled);
            changeButtonOnStatusBar($(".priloha_status_class" + stringSuffix).parent(), this.podepsatPrilohy.checked, this.podepsatPrilohy.enabled);
            changeButtonOnStatusBar($(".konverze_status_class" + stringSuffix).parent(), this.zkonvertovat.checked, this.zkonvertovat.enabled);

            // SPECIALITA MD
            changeButtonOnStatusBar($(".prideleni_status_class" + stringSuffix).parent(), this.pridelit.checked, this.pridelit.enabled);
            changeButtonOnStatusBar($(".predani_status_class" + stringSuffix).parent(), this.predat.checked, this.predat.enabled);
            changeButtonOnStatusBar($(".schvalit_vyrizeni_spisu_status_class" + stringSuffix).parent(), this.schvaleniVyrizeniSpisu.checked, this.schvaleniVyrizeniSpisu.enabled);

			// připojený soubor je definován?
			if (that.actions.actAttachedFile !== undefined) {
				// připojený soubor
				that.actions.actAttachedFile.update({
					enabled: this.pridatVyrizSoubor.enabled
				});
			}

		}

		/** nasetování dat do formuláře hlavičky detailu žádosti o podpis dokumentu */
		private setDataToForm() {
			this.findForms("formHeader").findFields().gfield("model", "apply", this.row, {
				initialValues: true
			})
		}

        private rSide: GEpkSidebar;

        /** vytvořit sidebar */
        private createSidebar() {

            var opt: IGEpkSidebar = {
                cnt: this,
                row: this.row!
            }
            this.rSide = new GEpkSidebar(opt);
            this.element.gsidebar({
                right: { pinned: false, panels: this.rSide.createRightPanels() }
            })

            this.createLeftSidebar();

        }

        private createLeftSidebar() {

            var div = $("<div>");
            if (this.EpkParams.epk_gfrmzobr === 1) {
                this.gfrmPanel = new Gordic.Epk.WebControls.Sidebar.GEpkGfrmPanel();
                this.element.gsidebar("addPanel", "left", this.gfrmPanel.create(this, this.row.ixp!));
            }

            this.element.gsidebar("addPanel", "left", {
                icon: "gi-paper",
                customDiv: div,
                id: "filelist",
                leaf: "jres:32000356",              //RC 32000356 : Soubory
                caption: "jres:32000356",
                //pinned: true,
                open: () => {
                    saveToUserSettings(this.userSettings!, "leftSidebar.filelistDetailOpen", true);
                },
                close: () => {
                    if (this.closed)
                        return;
                    saveToUserSettings(this.userSettings!, "leftSidebar.filelistDetailOpen", false);
                },
                width: 200
            } as GSbpanelOptions);

            // zavření contentu - ochrana kvůli pádu
            if (this.closed)
                return;
            if (loadFromUserSettings(this.userSettings!, "leftSidebar.filelistDetailOpen") === true) {
                $(this.element).gsidebar("getPanel", "filelist").gsbpanel("show");
            }
        }

        private fileSelectionRow: any;

		/** showAttachment */
		private showAttachment() {

            // zavření contentu - ochrana kvůli pádu
            if (this.closed)
                return;
            if (this.element == null)
                return;
			
            var nahled = $("<div class='nahled_class'>").appendTo(this.element); // zobrazení náhledu
            var filelist = this.element.gsidebar("getPanel", "filelist");
            filelist.off('.filelist');

            filelist.on('gbasepanelselection.filelist', Utils.debounced((ev, selection) => {

                // zavření contentu - ochrana kvůli pádu
                if (this.closed === true)
                    return;
                this.fileSelectionRow = selection;
                if (selection.File != null) {
                    // hodnoty musí být vyplněné
                    if ((selection.Ixp != null) && (selection.File.Ixb != null) && (selection.File.Name != null)) {
                        var ixb = selection.File.Ixb;

                        var filename: string = selection.File.Name;
                        filename = filename.trim();                     // (1.6.2023) T26960

                        var panel = this.element.gsidebar("getPanel", "panelOvereniPodpisu");
                        var visible = panel.gsbpanel("isVisible");
                        // provést pouze, když je panel otevřený
                        if (visible === true) {
                            this.rSide.setPanelOvereniPodpisu(ixb, filename);
                        }
                    }
                }
            }, 100));

            if (this.row != null && this.row.ixp != null) {

                nahled.gattachment({
                    ixp: this.row.ixp,
                    ixb_elp: this.row.ixb_elp,
                    ser_cislo: this.row.ser_cislo,
                    emptyMessage: "jres:32000215",   // RC 32000215 : Dokument nemá elektronický obraz.
                    autofitParentElement: ".ui-dialog-content",
                    serviceContent: "Gordic.Epk.WebControls.GEpkAttachmentService",
                    displayEngineOptions: {
                        pdfEngine: {
                            scrollMode: Gordic.Components.FilePreview.GPdfEngineScrollMode.Vertical
                        }
                    },
                    filePreviewOptions: {
                        modifymenubar: (ev, ctx) => {
                            new GEpkVisualPlacemenet().setVisualPlacementMenuParams(this, { menuBar: ctx.menuBar, row: this.row, fileSelectionRowFc: () => { return this.fileSelectionRow } });


                            const conversion: MenuParams = {
                                id: "idEpkKonverze",
                                action: new GAction({
                                    caption: "jres:32001060", //RC 32001060 : Vyhotovení PDF
                                    name: "actEpkConversion",
                                    run: () => {

                                        const file: { File: { Ixb: string }} = this.fileSelectionRow;

                                        if (file == null || file.File == null || file.File.Ixb == null) {
                                            console.error("jres:32001056"); //RC 32001056 : Není vyplněn identifikátor vybraného souboru.
                                            return;
                                        }

                                        if (this.Ixp == null) {
                                            console.error("jres:32001059"); //RC 32001059 : Není vyplněn identifikátor dokumentu.
                                            return;
                                        }

                                        /** identifikátor souboru */
                                        const ixb = file.File.Ixb;

                                        this.hideFlash("idEpkConversionFlash");
                                        Gordic.Wfl.Dialogs
                                            .GEpkConversionDlg(this, { Ixb: ixb, Ixp: this.Ixp })
                                            .then((output) => {
                                                this._load()
                                                    .then(() => {
                                                        if (output.Message == null) 
                                                            return;
                                                        this.showFlash({
                                                            id: "idEpkConversionFlash",
                                                            state: output.State ? "success" : "warning",
                                                            content: output.Message
                                                        });
                                                    })
                                            })

                                    }
                                })
                            }
                            ctx.menuBar.push(conversion);

                        },
                        customDownload: (input) => {
                            return new Gordic.Epk.WebControls.Sidebar.GEpkAttachment(this).customDownload(input, this.row);
                        }
                    },
                    fileListCustomLocation: filelist,
                    basePanelOptions: {mode: "vertical"}
                });
            }

         
        }



		/** validace detailu před vyřízením */
		private validateDetail() {
			/** je formulář validní? */
			var isValid = this.findForms().gform("isValid");
			return isValid;
        }

		/**
		 * nasetování statusbar tlačítek
		 */
		private setStatusButton() {

            var statusbar: MenuParams[] = [];

            //#region -- výběr barev --

            statusbar.push({
                customClass: "gcolorbox_status_class",
                id: "statusVyberBarvy",
                type: "widget",
                tooltip: "jres:32000541",	//RC 32000541 : Barevné označení
                init: () => {
                    var element = $("<div>");
                    element.gcolorpicker({
                        type: "epk",
                        globalSettings: this.globalSettings,
                        readonly: this.ReadOnly,
                        uzo: this.row.uzo,
                        change: (color) => {
                            Gordic.Isl.ColorpickerService.setUzo({ Opt: { Ixp: this.row?.ixp, SerCislo: this.row?.ser_cislo, Type: Wfl.Interface.GColorpickerTypeEnum.Request, Uzo: color } }).getData()
                                .then(() => {
                                    this.row.uzo = color;
                                    this.refresh = true;
                                })
                        }
                    });
                    return element;
                }
            });

            //#endregion

			//#region ** statusbar vyřízení **

			statusbar.push({
				customClass: "podepsat_status_class",
				id: "statusPodepsat",
				type: "static",
				icon: "gi-sign",
				tooltip: "jres:32000061"	//RC 32000061 : Při vyřízení žádosti podepsat dokument
            });

            if (this.EpkParams.ssl_epk_plus! > -1) {
                statusbar.push({
                    customClass: "schvalit_status_class",
                    id: "statusSchvalit",
                    type: "static",
                    icon: "gi-tick",
                    tooltip: "jres:32000060", //RC 32000060 : Při vyřízení žádosti schválit dokument
                });
            }

            if (this.EpkParams.ssl_epk_plus! > 0) {
                statusbar.push({
                    customClass: "posoudit_status_class",
                    id: "statusPosoudit",
                    type: "static",
                    icon: "fa-balance-scale",
                    tooltip: "jres:32000054", //RC 32000054 : Vyřídit žádost posouzením
                });
            }

            if (this.EpkParams.ssl_epk_plus! === 2 || this.EpkParams.ssl_epk_plus! === 3) {
                // Vzít na vědomí
                statusbar.push({
                    customClass: "vzitnavedomi_status_class",
                    id: "statusVzitNaVedomi",
                    type: "static",
                    icon: "gi-transmit",
                    tooltip: "jres:32000207", //RC 32000207 : Vzít na vědomí
                });

                if (this.EpkParams.ssl_epk_plus! === 3) {
                    // Splnit (Specialita pro Ukrajinu)
                    statusbar.push({
                        customClass: "splnit_status_class",
                        id: "statusSplnit",
                        type: "static",
                        icon: "fa-check-square-o",
                        tooltip: "jres:32000429", //RC 32000429 : Splnit
                    });
                    // Splnit (Specialita pro Ukrajinu)
                    statusbar.push({
                        customClass: "rozhodnout_status_class",
                        id: "statusRozhodnout",
                        type: "static",
                        icon: "fa-gavel",
                        tooltip: "jres:32000450", //RC 32000450 : Rozhodnout
                    });
                }
            }

            if (this.EpkParams.ssl_epk_plus2 === true) {
                // SPECIALITA PRO MD
                if (this.pridelit.visible === true) {
                    statusbar.push({
                        customClass: "prideleni_status_class",
                        id: "statusPrideleni",
                        type: "static",
                        icon: "gi-pridelit",
                        tooltip: "jres:32000626", //RC 32000626 : Přidělení
                    });
                }
                if (this.predat.visible === true) {
                    statusbar.push({
                        customClass: "predani_status_class",
                        id: "statusPredani",
                        type: "static",
                        icon: "gi-predat",
                        tooltip: "jres:32000627", //RC 32000627 : Předání
                    });
                }
                if (this.schvaleniVyrizeniSpisu.visible === true) {
                    statusbar.push({
                        customClass: "schvalit_vyrizeni_spisu_status_class",
                        id: "statusSchvaleniVyrizeniSpisu",
                        type: "static",
                        icon: "gi-folder|gi-schvaleno gi-stack-pos--rb gi-bgw",
                        tooltip: "jres:32000642", //RC 32000642 : Schválení vyřízení spisu
                    });
                }
            }
		
			statusbar.push({
				customClass: "casrazitko_status_class",
				id: "statusCasRazitko",
				type: "static",
				icon: "gi-signtime",
				tooltip: "jres:32000052", //RC 32000052 : Přidat k podpisu časové razítko
            });

            if (Gordic.Wfl.WebClient.GetGWflDBParams().IsUkraine !== true) {    // ukrajina nemá hromadné vyřízení

                statusbar.push({
                    customClass: "priloha_status_class",
                    id: "statusPriloha",
                    type: "static",
                    icon: "gi-attachment",
                    tooltip: "jres:32000050", //RC 32000050 : Včetně příloh
                });

            }

            if (this.zkonvertovat.visible === true) {
                statusbar.push({
                    customClass: "konverze_status_class",
                    id: "statusKonverze",
                    type: "static",
                    icon: "gi-convert",
                    tooltip: "jres:32000250", //RC 32000250 : Zkonvertovat
                });
            }

         

			
			//#endregion

            //#region ** termín vyřízení **

            if (this.ReadOnly === false) {
                var dat_vyriz_plan = this.row.dat_vyriz_plan;

                if (dat_vyriz_plan != null) {

                    if (typeof dat_vyriz_plan === "string")
                        dat_vyriz_plan = Gordic.Utils.DateTime.parse(dat_vyriz_plan);

                    var today = new Date() as any;
                    // rozdíl jako dny
                    let diff_days = Gordic.Utils.DateTime.diff(today, dat_vyriz_plan, "days");

                    if (diff_days < 0) {
                        statusbar.push({
                            align: "opposite",
                            customClass: "g-state-text g-state-error",
                            id: "statusTerminVyrizeni",
                            type: "static",
                            caption: "jres:26265030"     //RC 26265030 : Nevyřízeno po
                        });
                    }
                    else {
                        if (diff_days < this.EpkParams.gin_epk_updoter!) {
                            statusbar.push({
                                align: "opposite",
                                customClass: "g-state-text g-state-warning",
                                id: "statusTerminVyrizeni",
                                type: "static",
                                caption: "jres:26265031"     //RC 26265031 : Nevyřízeno těsně před
                            });
                        }
                    }
                }
            }
         
            //#endregion

            //#region ** priorita **

            var priorita = this.row.priorita;

            if (priorita === 2) {
                statusbar.push({
                    align: "opposite",
                    customClass: "g-state-text g-state-error",
                    id: "statusPriorita",
                    type: "static",
                    caption: "jres:32000313"     //RC 32000313 : Vysoká priorita
                });
            }

            //#endregion
            //#region ** opakovaně předložená žádost **

            if (this.epk_txtopr !== undefined) {
                statusbar.push({
                    align: "opposite",
                    customClass: "g-state-text g-state-error",
                    id: "statusOpakPredlozZadost",
                    type: "static",
                    caption: this.epk_txtopr
                } as MenuParams);
            }

            //#endregion


            if (this.EpkOpt.povoleniFikceVyrizeni === true) {   // thazmuka 14.10.2021
                if (this.row.priz_fikce_vyrizen === 1) {
                    statusbar.push({
                        align: "opposite",
                        customClass: "g-state-text g-state-error",
                        id: "statusFikce",
                        type: "static",
                        caption: "jres:32000792" //RC 32000792 : Fikce vyřízení
                    } as MenuParams);
                }
            }

            if (this.OwnRequest) {
                statusbar.push({
                    align: "opposite",
                    customClass: "g-state-text g-state-error",
                    id: "ownRequestId",
                    type: "static",
                    caption: "jres:32000921" //RC 32000921 : Vlastní žádost
                } as MenuParams);
            }

            this.statusBar(statusbar);
		}

		//#endregion

		//#region *** připojení vyřízujícího souboru ***

        private vyrizDlg: JQuery<HTMLElement>;

		/**
		 * zobrazit dialog
		 */
		public showPripojVyrizSoubor(): JQueryPromise<any> {

			let dfd = $.Deferred();
			let __this = this;

			var fileInfo = this.fileInfo;

			//#region form

			let form = $("<div>");
			let formFileField = new Gordic.Forms.Form({ name: "formFileField" })		// po doplneni .d.ts smazat

			formFileField
				.addSection()
				.addRow("jres:32000016") //RC 32000016 : Soubor
				.addField("gfilefield", {
					name: "attached_file",
                    maxFileCount: 1,
                    itemDownloadable: true,
					fileRemoved: function (ev, obj) {

						fileInfo.filename = "";
						fileInfo.guid = "";

						let modalContent = $.content(this as any);
                        modalContent.showFlash({
                            content: "jres:32000016 " + obj.fileInfo.filename + " jres:32000058.", //RC 32000058 : byl smazán
                            state: "info",
                            id: "idAttachedFileRemoved"
                        });

						modalContent.findFields().gfield("clear");
						fileInfo.title = "";
						fileInfo.description = "";

					},
					fileUploaded: function (ev, obj) {

						fileInfo.filename = obj.fileInfo.filename!;
						fileInfo.guid = obj.fileInfo.guid!;

                        let modalContent = $.content(this as any);
                        modalContent.showFlash({
                            id: "idAttachedFileUploaded",
                            content: "jres:32000016 " + obj.fileInfo.filename + " jres:32000057.", //RC 32000057 : byl nahrán
                            state: "info"
                        });

						let fileWithoutExtension = obj.fileInfo.filename!.split('.').slice(0, -1).join('.');
						fileInfo.title = fileWithoutExtension;
						fileInfo.description = fileWithoutExtension;
						modalContent.findFields("titulek").gfield("setValue", fileWithoutExtension);
						modalContent.findFields("popis").gfield("setValue", fileWithoutExtension);

					},

					// soubor byl stažen
					fileDownloaded: function (ev, obj) {

                        let modalContent = $.content(this as any);

                        modalContent.showFlash({
                            id: "idAttachedFileDownloaded",
                            content: "jres:32000016 " + obj.fileInfo.filename + " jres:32000059.", //RC 32000059 : byl stažen
                            state: "info"
                        });
	
					}

				})

				.addRow("jres:32000056, jres:32000005") // Titulek, Popis
				.addField("gstringbox", {
					name: "titulek",
					customClass: "w-6",
					change: (ev, obj) => {
						fileInfo.title = obj.value!;
					}
				})
				.addField("gstringbox", {
					name: "popis",
					customClass: "w-6",
					change: (ev, obj) => {
						fileInfo.description = obj.value!;
					}
				})

			form.gform("createFrom", formFileField);

			// dropzona na políčku
			form.findFields("attached_file").gfilefield("addDropzone");

			//#endregion

            this.vyrizDlg = this.dialogs.showModalWindow(form, null, {
				width: 740,
				height: 240,
				title: "jres:32000361", //RC 32000361 : Přidat vyřizující soubor
				commandBar: [{
					action: new GAction({
						name: "actOk",
						caption: "Ok",
						run: function (ev: any, ctx) {
                            //this.content.tryCloseAllSignificants();
                            __this.vyrizDlg.dialog("close");
						}
					})
				}]
			});

            this.vyrizDlg.on('close', () => {
				this.setTextOnAttachedFileBadge(fileInfo);
				dfd.resolve(fileInfo);
			});

			// existuje připojený soubor
			if (fileInfo.guid !== "") {

                //pnovak - TODO zde bys mel vytvorit servisni content navazany na content a tento content nevytvaret pokazde novy, udelat si instanci
				new GContent("Gordic.Gui.WebControls.GFileInfoServiceProvider").call("GetFileInfos", { uids: [fileInfo.guid] }).done((data) => {
                    this.vyrizDlg.findFields(".gfilefield").gfield("model", "apply", { "attached_file": data });
				});

                this.vyrizDlg.findFields("titulek").gfield("setValue", fileInfo.title);
                this.vyrizDlg.findFields("popis").gfield("setValue", fileInfo.description);
			}


			return dfd.promise();
		}

		/**
		 * nastavit text na badge připojeného souboru
		 * @param {any} that gcontent
		 * @param {EpkUtils.EpkFileInfo} fileInfo informace o souboru
		 */
		private setTextOnAttachedFileBadge(fileInfo: EpkFileInfo): void {

			// smazat badge u menubar ikony
			$(".attached_file_badge").remove();

			let str = fileInfo.filename;

			if (str.length > 20) {
				let extension = fileInfo.filename.split('.').pop();
				str = str.substring(0, 20);
				str = str + "..." + extension;
			}

			if (fileInfo.guid !== "") {
                this.badgeFile = $("<div class='attached_file_badge'>")
                    .appendTo(".g-button.attached_file_class").first()
                    .gbadge({ value: str });
			}

		}

		//#endregion

        //#region *** USERSETTINGS SIDEBAR ***

        /**
        * uložit nastavení panelu
        * @param panel panel
        * @param open příznak uložení
        */
        saveSettingPanel(panel: string, open: boolean) {

            if (this.userSettings !== undefined && this.userSettings !== null) {
                // clear
                this.userSettings.set("epk.detail.sidebar.right.souhrn", false);
                this.userSettings.set("epk.detail.sidebar.right.nahled", false);
                this.userSettings.set("epk.detail.sidebar.right.souvisejici", false);
                this.userSettings.set("epk.detail.sidebar.right.poznamky", false);
                this.userSettings.set("epk.detail.sidebar.right.historieschvalovani", false);
                this.userSettings.set("epk.detail.sidebar.right.overenipodpisu", false);

                // set panel (true)
                this.userSettings.set("epk.detail.sidebar.right." + panel, open);
            }
        }

        /**
        * uložit nastavení (false) všech panelů po odpinování
        * @param open
        */
        saveSettingPanelAll(open: boolean) {
            if (this.userSettings !== undefined && this.userSettings !== null) {
                this.userSettings.set("epk.detail.sidebar.right.souhrn", open);
                this.userSettings.set("epk.detail.sidebar.right.nahled", open);
                this.userSettings.set("epk.detail.sidebar.right.souvisejici", open);
                this.userSettings.set("epk.detail.sidebar.right.poznamky", open);
                this.userSettings.set("epk.detail.sidebar.right.historieschvalovani", open);
                this.userSettings.set("epk.detail.sidebar.right.overenipodpisu", open);
            }
        }

        //#endregion


	}




}
